import React, { useEffect, useState } from "react";

import ProfileDropdown from "../Components/Common/ProfileDropdown";
import { Link } from "react-router-dom";
import NotificationDropdown from "../CosmosAdminPages/Notifications/NotificationDropdown";
import KOTList from "../OrderingSystem/POS/KOT/page/KOTList";
import { getLoggedInUser } from "../helpers/fakebackend_helper";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import FoodCourt from "../OrderingSystem/POS/page/Table/page/FoodCourt";

const SecondaryHeader = ({
  sectionData,
  setSelectedSection,
  selectedSection,

  isTableOpen,
  setIsTableOpen,
  handleRefresh,
  isRefreshing,
  fetchTable,
  fetchSection,
  setSelectedCourt,
}) => {
  // console.log("authUserr", authUser);
  useEffect(() => {
    const isMobile = window.innerWidth < 992; // Bootstrap lg breakpoint
    setIsTableOpen(isMobile); // Only open on small screens initially
  }, []);
  const [tableOpen, setTableOpen] = useState(false);
  const toggleTableModal = () => setTableOpen(!tableOpen);
  const [loading, setLoading] = useState(false);

  return (
    <header className="bg-light rounded-4">
      <div
        className="w-100  d-flex justify-content-between align-items-center"
        style={{ height: "60px" }}
      >
        {/* Left: Hamburger + Logo */}
        <div className="d-flex align-items-center ">
          {/* <button
            onClick={toggleSidebar}
            type="button"
            className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn"
          >
            <span className="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button> */}

          <span className="logo-sm">
            {/* <img src={logoSm} alt="" height="22" /> */}

            <img
              src={"/" + window.APP_CONFIG.tenent + "/restroorder.png"}
              alt=""
              height="35"
            />
          </span>
        </div>

        {/* Right: POS + Notification + Profile */}
        <div className="d-flex align-items-center gap-3">
          {/* {userRole !== "waiter" ? (
            <>
              <button
                className="btn btn-soft-dark btn-sm d-lg-block d-none"
                onClick={confirmToggle}
              >
                <i className="ri-tv-2-line"></i> Dashboard
              </button>
              <Link to="/dashboard">
                <button className="btn btn-soft-dark btn-sm d-lg-none d-md-none d-block">
                  <i className="ri-tv-2-line"></i>
                </button>
              </Link>
            </>
          ) : null} */}
          <div
            className="d-flex align-items-center gap-2 cursor-pointer"
            onClick={!isRefreshing ? handleRefresh : null}
          >
            <i
              className={`ri-refresh-line fs-4 text-success ${
                isRefreshing ? "refresh-rotate" : ""
              }`}
              title="Refresh"
              style={{ opacity: isRefreshing ? 0.5 : 1 }}
            ></i>

            {isRefreshing && <span style={{ fontSize: "14px" }}></span>}
          </div>
          <div
            className="d-flex d-lg-none align-items-center gap-2 cursor-pointer"
            onClick={toggleTableModal}
          >
            <i
              className="ri-restaurant-line fs-4 text-success"
              title="Select Table"
            ></i>
            <div>
              <h6 className="mb-0 fw-semibold">
                {setSelectedCourt?.TableKey || "Table"}
              </h6>
            </div>
          </div>
          {/* <button
            className="btn btn-soft-success btn-sm d-lg-flex d-none  align-items-center gap-2 cursor-pointer px-3"
            onClick={toggleKotOpen}
          >
            <i class="ri-file-list-3-line fs-6"></i>

            <h6 className="mb-0 fw-semibold">KOT</h6>
          </button> */}
          {/* <button
            className="btn btn-soft-success btn-sm d-lg-none d-flex  align-items-center gap-2 cursor-pointer "
            onClick={toggleKotOpen}
          >
            <i class="ri-file-list-3-line fs-4"></i>

            <h6 className="mb-0 fw-semibold">KOT</h6>
          </button> */}
          {/* <NotificationDropdown /> */}
          <ProfileDropdown />
        </div>
      </div>
      <FoodCourt
        isOpen={tableOpen}
        toggle={toggleTableModal}
        // data={data}
        data={sectionData}
        setSelectedSection={setSelectedSection}
        selectedSection={selectedSection}
        loading={loading}
        fetchTable={fetchTable}
        fetchSection={fetchSection}
        setSelectedCourt={setSelectedCourt}
      />
    </header>
  );
};

export default SecondaryHeader;
